const isFilesNumInvalid = (fileList, docsLength, maxDocs) => {
  return fileList.length + docsLength > maxDocs;
}

export default isFilesNumInvalid;